function buttonClick(orders){

  let formData = {
    items: []
  };


  orders.forEach(order => {
    formData.items.push({
      id: order.vid,
      quantity: order.quantity,
      properties: {
        'モデル': order.model
      } 
    });
  });

  fetch("/cart/add", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
  .catch((error) => {
    console.error("Error:", error)
  })
}